import styles from './index.module.scss'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState, useContext } from 'react'
import eventBus from "@utils/eventBus";
import { Button, Dropdown, Slider, Space, Switch, message, Segmented, Popover, Input, Select } from "antd"
import Iconfont from '@utils/Iconfont';
import { useNavigate } from "react-router";
import PSAIModal from '@PSAIComponents/PSAIModal';
import { GENERATE_MODE, BATCH_IMAGES_TYPE, RELIGHT_MODE, UPLOAD_SOURCE, RESOLUTION_ALIGN, MODEL_EXPRESSION, MODEL_PROVIDER } from "@utils/CONST"
import Utils from '@utils/utils';
import API from "@api/api";
import { BatchImagesContext } from "../BatchImagesContext"
import { QuestionCircleOutlined, RightOutlined, LoadingOutlined } from '@ant-design/icons';
import { getSmartDetailImageCount } from './components/SmartDetailPageConfigBar'
const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/'

const modeItems = [{
    value: GENERATE_MODE.STD,
    title: "标准模式",
    content: "生成速度更快",
    icon: <Iconfont type="icon-stdOutlined" />,
    iconActive: <Iconfont type="icon-stdFilled" />,
}, {
    value: GENERATE_MODE.HQ,
    title: "高品质模式",
    content: "生成效果更好",
    icon: <Iconfont type="icon-hdOutlined" />,
    iconActive: <Iconfont type="icon-hdFilled" />,
    // isLimit: true,
}]

const modelProviderItems = [{
    value: MODEL_PROVIDER.ARCMUSE,
    title: "ArcMuse",
}, {
    value: MODEL_PROVIDER.SOTA,
    title: "全能模型",
}]

const resolutionAlignItems = [{
    value: RESOLUTION_ALIGN.INPUT,
    title: "上传图比例",
    content: "按上传图比例生成",
}, {
    value: RESOLUTION_ALIGN.BKG,
    title: "参考图比例",
    content: "按已选背景参考图比例",
}]

const durationItems = [{
    value: 5,
    title: '5s',
}, {
    value: 10,
    title: '10s',
}]

const smartDetailRatioOptions = [
    { label: '2:3', value: '2:3' },
    { label: '1:1', value: '1:1' },
    { label: '3:4', value: '3:4' },
    { label: '16:9', value: '16:9' },
    { label: '9:16', value: '9:16' },
    { label: '3:2', value: '3:2' },
    { label: '4:3', value: '4:3' },
]

const smartDetailPlatformOptions = [
    { label: '淘宝', value: 'taobao' },
    { label: '天猫', value: 'tmall' },
    { label: '京东', value: 'jd' },
    { label: '拼多多', value: 'pdd' },
    { label: '抖音电商', value: 'douyin_shop' },
    { label: '唯品会', value: 'vip' },
    { label: '1688', value: '1688' },
    { label: '小红书', value: 'xiaohongshu' },
    { label: '亚马逊', value: 'amazon' },
    { label: 'Tik Tok', value: 'tiktok' },
    { label: 'Shopify', value: 'shopify' },
]

const smartDetailLangOptions = [
    { label: '中文', value: 'cn' },
    { label: '英文', value: 'en' },
    { label: '俄文', value: 'ru' },
]

const smartDetailPlatformMap = {
    taobao: '淘宝',
    tmall: '天猫',
    jd: '京东',
    pdd: '拼多多',
    douyin_shop: '抖音电商',
    vip: '唯品会',
    '1688': '1688',
    xiaohongshu: '小红书',
    amazon: '亚马逊',
    tiktok: 'Tik Tok',
    shopify: 'Shopify',
}

const smartDetailControlWidth = 324
const smartDetailControlHeight = 32
const smartDetailClarityItemWidth = 156
const smartDetailLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    height: smartDetailControlHeight,
    lineHeight: `${smartDetailControlHeight}px`,
}

const getSmartDetailPromptText = (data) => {
    if (typeof data === 'string') return data.trim()
    if (!Array.isArray(data)) return ''
    return data
        .map((item) => {
            if (item && typeof item === 'object' && typeof item.description === 'string') {
                return item.description.trim()
            }
            if (typeof item === 'string') return item.trim()
            return ''
        })
        .filter(Boolean)
        .join('\n')
        .trim()
}

const getSmartDetailPromptImages = (inputImages = []) => {
    return (inputImages || [])
        .map((image, index) => {
            if (!image) return ''
            if (typeof image === 'string') {
                return {
                    url: image,
                    main: index === 0,
                }
            }
            if (!image?.url) return ''
            return {
                url: image.url,
                main: Boolean(image?.mainImage ?? image?.main ?? (index === 0)),
            }
        })
        .filter(Boolean)
}

const hasSmartDetailInputImages = (item) => {
    return getSmartDetailPromptImages(item?.inputImages).length > 0
}

const FooterBar = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleBatchExit
    }))
    const { setIsBatchAppendSmartPage } = useContext(BatchImagesContext)
    const navigate = useNavigate()
    const {
        projectType,
        uploading,
        selectedRowKeys,
        selectedRows,
        onAddMore,
        skuNumber,
        projectId,
        isEdit,
        dataSource,
        setDataSource,
        smartDetailConfigItems = []
    } = props
    const [batchMode, setBatchMode] = useState()
    const [submitConfigVisible, setSubmitConfigVisible] = useState(false)
    const [handleNumber, setHandleNumber] = useState(
        projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ||
            projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? 1 : 4
    )
    const [generateMode, setGenerateMode] = useState(GENERATE_MODE.STD)
    const [modelProvider, setModelProvider] = useState(MODEL_PROVIDER.ARCMUSE)
    const [duration, setDuration] = useState(5)
    const [resolutionAlign, setResolutionAlign] = useState(RESOLUTION_ALIGN.INPUT)
    const [switchChecked, setSwitchChecked] = useState(false)
    const [switchChecked2, setSwitchChecked2] = useState(false)
    const [relight, setRelight] = useState(0.0)
    const [loading, setLoading] = useState(false)
    const [createLoading, setCreateLoading] = useState(false)
    const [total, setTotal] = useState(0)
    const [relightMode, setRelightMode] = useState(projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? RELIGHT_MODE.PORTRAIT : RELIGHT_MODE.SKIN)
    const [emoji, setEmoji] = useState(MODEL_EXPRESSION.SRC)
    const [promptModalOpen, setPromptModalOpen] = useState(false)
    const [promptDesc, setPromptDesc] = useState('')
    const [smartDetailRatio, setSmartDetailRatio] = useState('3:4')
    const [smartDetailPlatform, setSmartDetailPlatform] = useState('taobao')
    const [smartDetailLang, setSmartDetailLang] = useState('cn')
    const [submitPrepareLoading, setSubmitPrepareLoading] = useState(false)

    useEffect(() => {
        if (projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH || projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
            setHandleNumber(1)
        }
        setRelightMode(projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? RELIGHT_MODE.PORTRAIT : RELIGHT_MODE.SKIN)
    }, [projectType])

    useEffect(() => {
        if (projectType !== BATCH_IMAGES_TYPE.TRYON_BATCH) return
        if (!isEdit) return
        const provider = dataSource?.[0]?.attr?.modelProvider || dataSource?.[0]?.modelProvider
        setModelProvider(provider || MODEL_PROVIDER.ARCMUSE)
    }, [projectType, isEdit, dataSource])

    const modeItemsWithLabel = useMemo(() => {
        const isTryonSota = projectType == BATCH_IMAGES_TYPE.TRYON_BATCH && modelProvider == MODEL_PROVIDER.SOTA
        return modeItems.map(item => ({
            ...item,
            title: isTryonSota
                ? (item.value == GENERATE_MODE.HQ ? '高品质模式4K' : '标准模式2K')
                : (item.value == GENERATE_MODE.HQ ? '高品质模式' : '标准模式')
        }))
    }, [projectType, modelProvider])

    const getSmartDetailNum = (data) => {
        if (typeof data === 'number') return data
        if (Array.isArray(data)) return Number(data?.[0]?.pre_count ?? data?.[0]?.num ?? data?.[0]?.count ?? data?.[0]?.imageNum ?? data.length) || 0
        if (data && typeof data === 'object') return Number(data.num ?? data.count ?? data.imageNum ?? data.total) || 0
        return 0
    }

    const validateBeforeGenerate = () => {
        const processedDataSource = dataSource.map(item => {
            const newItem = { ...item }

            if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH && (!item.refList || item.refList.length === 0)) {
                newItem.error = true
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH && (!item.modelList || item.modelList.length === 0)) {
                newItem.error = true
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && (!item.bkgList || item.bkgList.length === 0)) {
                newItem.error = true
            } else if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                (!hasSmartDetailInputImages(item) || !(item?.prompt || '').trim())) {
                newItem.error = true
            } else if (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH && !item.inputCloth) {
                newItem.error = true
            } else if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && !(item?.prompt || '').trim()) {
                newItem.error = true
            } else {
                newItem.error = false
                newItem.error2 = false
            }
            return newItem
        })

        setDataSource(processedDataSource)

        const hasErrorItems = processedDataSource.some(item => item.error === true)
        const hasError2Items = processedDataSource.some(item => item.error2 === true)

        if (hasError2Items) {
            message.error('请填写完整商品颜色、类目、模板！')
            return false
        }

        if (hasErrorItems) {
            if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
                message.error('请填写完整视频画面描述！')
            } else {
                message.error('存在必填信息缺失的项，请先填写完整！')
            }
            return false
        }

        return true
    }

    const prepareSmartDetailSubmit = async () => {
        if (projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) return true

        const pendingRows = (dataSource || []).filter((item) => {
            if (!(Array.isArray(item?.refList) && item.refList.length > 0)) return false
            const selectedItem = item.refList?.[0]
            const presetNum = Number(selectedItem?.attr?.detailPageNum ?? selectedItem?.detailPageNum) || 0
            if (presetNum > 0) return true
            return !(Number(item?.detailPageNum) > 0)
        })

        if (!pendingRows.length) return true

        setSubmitPrepareLoading(true)
        try {
            const updatedRows = await Promise.all(pendingRows.map(async (item) => {
                const selectedItem = item?.refList?.[0]
                const presetNum = Number(selectedItem?.attr?.detailPageNum ?? selectedItem?.detailPageNum) || 0

                if (presetNum > 0) {
                    return {
                        ...item,
                        detailPageNum: presetNum,
                    }
                }

                if (!selectedItem?.key) throw new Error('参考详情图缺少分析参数')

                const res = await API.doDetailPageNum({
                    key: selectedItem.key,
                    custom: selectedItem?.custom ? 1 : 0,
                })
                if (res?.code !== 0) throw new Error(res?.message || '参考详情图分析失败')
                const detailPageNum = getSmartDetailNum(res?.data) || getSmartDetailNum(res?.attr) || 0
                if (!detailPageNum) throw new Error('参考详情图分析结果为空')
                if (selectedItem?.custom && selectedItem?.key) {
                    try {
                        const imageUrl = selectedItem?.url || selectedItem?.imageUrlWithVersion || selectedItem?.imageUrl || ''
                        if (!imageUrl) throw new Error('参考图缺少url')
                        await API.saveCustomMaterialv2({
                            id: selectedItem?.id || selectedItem?.key,
                            image: imageUrl,
                            attr: { detailPageNum },
                        })
                    } catch (e) { }
                }

                return {
                    ...item,
                    detailPageNum,
                }
            }))

            if (!updatedRows.length) return true

            const updatedMap = new Map(updatedRows.map(item => [item.skuId, item.detailPageNum]))
            setDataSource(prev => prev.map(item => (
                updatedMap.has(item.skuId)
                    ? { ...item, detailPageNum: updatedMap.get(item.skuId) }
                    : item
            )))

            const payload = updatedRows.map(({ error, error2, ...rest }) => rest)
            const saveRes = await API.batchSaveSku(payload)
            if (saveRes?.code !== 0) throw new Error(saveRes?.message || '详情页数量保存失败')
            return true
        } catch (err) {
            message.warning(err?.message || '参考详情图分析失败')
            return false
        } finally {
            setSubmitPrepareLoading(false)
        }
    }

    const openSubmitConfig = async () => {
        if (submitPrepareLoading) return
        if (!validateBeforeGenerate()) return
        setSubmitConfigVisible(true)
    }

    const getSmartDetailGenerateParams = (submitMode) => {
        if (projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) return {}
        return {
            mode: submitMode === GENERATE_MODE.HQ ? '4K' : '2K',
            aspectRatio: smartDetailRatio || '3:4',
            ecPlatform: smartDetailPlatformMap[smartDetailPlatform] || smartDetailPlatformMap.taobao,
            lang: smartDetailLang || 'cn',
        }
    }

    const handleBatchAction = (key) => {
        setBatchMode(key)
        props.getBatchMode(key)
        props.setShowSelectionColumn(true)
    }

    const handleBatchClick = ({ key }) => {
        if (key === 'appendPromptGroup') return
        handleBatchAction(key)
    }
    const handleBatchExit = () => {
        setBatchMode()
        setIsBatchAppendSmartPage(false)
        props.setShowSelectionColumn(false)
        props.setSelectedRowKeys([])
        props.setSelectedRows([])
    }

    // 暴露handleBatchExit方法给父组件
    useImperativeHandle(ref, () => ({
        handleBatchExit
    }))

    const handleBatchSubmit = async () => {
        if (batchMode == 'appendImageTail') {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png';
            input.onchange = async (e) => {
                try {
                    let file = e.target.files[0];
                    if (file) {
                        setLoading(true)
                        const isNromal = await Utils.validateImageFileToVideo(file)
                        if (!isNromal) { setLoading(false); return }
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                        if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message) }
                        file = resizeRes.file
                        const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
                        if (!legalRes || !legalRes.isLegal) { message.warning(legalRes?.message); setLoading(false); return; }
                        await saveUploadImg(legalRes.data)
                    }
                } catch (error) {
                    setLoading(false)
                }
            }
            input.click();
        } else if (batchMode == 'appendTop' || batchMode == 'appendBottom') {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/webp,image/avif';
            input.onchange = async (e) => {
                try {
                    let file = e.target.files[0];
                    if (file) {
                        setLoading(true)
                        // 检查文件类型和宽高比
                        const isNromal = await Utils.validateImageFile(file)
                        if (!isNromal) { setLoading(false); return }
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                        if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message) }
                        file = resizeRes.file
                        const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
                        if (!legalRes || !legalRes.isLegal) { message.warning(legalRes?.message); setLoading(false); return; }

                        // 检测上传图类型
                        const clothType = await API.getClothType({ imageUrl: legalRes?.data })
                        const clothTextList = ['上装', '下装', null, '裙装']
                        if ((clothType?.data === 0 && batchMode == 'appendTop') ||
                            (clothType?.data === 1 && batchMode == 'appendBottom')) {
                            saveUploadImg(legalRes.data)
                        } else {
                            PSAIModal.confirm({
                                title: `系统检测到您上传的图片可能是${clothTextList[clothType.data]}`,
                                okText: "继续填入",
                                cancelText: `取消上传`,
                                onOk() {
                                    saveUploadImg(legalRes.data)
                                },
                                onCancel() {
                                    setLoading(false)
                                }
                            })
                        }
                    }
                } catch (error) {
                    setLoading(false)
                }
            }
            input.click();
        } else if (batchMode == 'appendCSimRecolorInput' || batchMode == 'appendCSimRecolorMaterial' || batchMode == 'appendCSimRecolorMatch') {
            const markSelectedSkuLoading = (loadingValue) => {
                setDataSource(prev => prev.map(item => (
                    selectedRowKeys.includes(item.skuId)
                        ? { ...item, matchLoading: loadingValue }
                        : item
                )))
            }
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/webp,image/avif';
            input.onchange = async (e) => {
                try {
                    let file = e.target.files[0];
                    if (file) {
                        setLoading(true)
                        markSelectedSkuLoading(true)
                        const isNromal = await Utils.validateImageFile(file)
                        if (!isNromal) { setLoading(false); markSelectedSkuLoading(false); return }
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                        if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message) }
                        file = resizeRes.file
                        const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
                        if (!legalRes || !legalRes.isLegal) { message.warning(legalRes?.message); setLoading(false); markSelectedSkuLoading(false); return; }
                        if (batchMode == 'appendCSimRecolorInput' || batchMode == 'appendCSimRecolorMaterial') {
                            const isMaterialMode = batchMode == 'appendCSimRecolorMaterial'
                            setDataSource(prev => prev.map(item => {
                                if (selectedRowKeys.includes(item.skuId)) {
                                    return {
                                        ...item,
                                        inputCloth: legalRes.data,
                                        matchLoading: false,
                                        // 上传成功后再统一切换平铺图类型：
                                        // cloth 模式会重置为 '' 以触发自动识别；material 模式不触发自动识别
                                        flatType: isMaterialMode ? 'material' : 'cloth',
                                        clothType: isMaterialMode
                                            ? (item.clothType === '' || item.clothType === undefined || item.clothType === null ? 0 : item.clothType)
                                            : ''
                                    }
                                }
                                return item
                            }))
                        } else {
                            setDataSource(prev => prev.map(item => {
                                if (selectedRowKeys.includes(item.skuId)) {
                                    return {
                                        ...item,
                                        matchCloth: legalRes.data,
                                        matchLoading: false,
                                    }
                                }
                                return item
                            }))
                        }
                        setLoading(false)
                        handleBatchExit()
                    }
                } catch (error) {
                    setLoading(false)
                    markSelectedSkuLoading(false)
                }
            }
            input.click();
        } else if (batchMode == 'appendCustomBkg') {
            let customBkgMode = 'free'
            PSAIModal.confirm({
                title: <>
                    <p style={{ marginBottom: 12 }}>批量设置场景相似度</p>
                    <Segmented
                        options={[
                            { label: '变化更多', value: 'free' },
                            { label: '场景不变', value: 'sim' }
                        ]}
                        onChange={(value) => {
                            customBkgMode = value
                        }}
                    />
                </>,
                okText: "确认",
                cancelText: `取消`,
                onOk() {
                    setDataSource(prev => prev.map(item => {
                        if (selectedRowKeys.includes(item.skuId)) {
                            return {
                                ...item,
                                customBkgMode: customBkgMode,
                            }
                        }
                        return item
                    }))
                    handleBatchExit()
                },
                onCancel() {
                    setLoading(false)
                }
            })
        } else if (batchMode == 'appendSmartPrompt') {
            if (!selectedRows?.length) return
            setLoading(true)
            try {
                const validRows = selectedRows.filter(item => hasSmartDetailInputImages(item))
                if (!validRows.length) {
                    message.warning('请先为选中的商品添加衣服图/模特图')
                    return
                }
                const promptResults = await Promise.all(validRows.map(async (item) => {
                    const res = await API.doDetailPagePrompt(getSmartDetailPromptImages(item?.inputImages))
                    if (res?.code !== 0) throw new Error(res?.message || 'AI分析失败，请重试')
                    const prompt = getSmartDetailPromptText(res?.data)
                    if (!prompt) throw new Error('AI分析失败，请重试')
                    return {
                        skuId: item.skuId,
                        prompt,
                    }
                }))
                setDataSource(prev => prev.map(item => {
                    const target = promptResults.find(promptItem => promptItem.skuId === item.skuId)
                    return target ? { ...item, prompt: target.prompt } : item
                }))
                if (validRows.length < selectedRows.length) {
                    message.warning(`有 ${selectedRows.length - validRows.length} 条未配置衣服图/模特图，已跳过`)
                }
                message.success('AI分析完成')
                handleBatchExit()
            } catch (error) {
                message.error(error.message)
            } finally {
                setLoading(false)
            }
        } else if (batchMode == 'appendSmartDetailRefer') {
            props.openReferenceDrawer([], 1, {}, BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH)
        } else if (batchMode == 'appendModel') {
            props.openReferenceDrawer(
                [], (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH || projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) ?
                1 : 10, {}, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)
        } else if (batchMode == 'appendBkg') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)
        } else if (batchMode == 'appendTryon') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.TRYON_BATCH)
        } else if (batchMode == 'appendPromptModel') {
            setPromptDesc('')
            setPromptModalOpen(true)
        } else if (batchMode == 'appendPrompt') {
            props.openReferenceDrawer('', 1, {}, BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH)
        } else if (batchMode == 'delete') {
            props.handleRemove(selectedRows.map(item => item.skuId))
        } else if (batchMode == 'appendCategory') {
            setIsBatchAppendSmartPage(true)
            props.handleAppendCategory(selectedRows.map(item => item.skuId))
        } else if (batchMode == 'appendTemplate') {
            setIsBatchAppendSmartPage(true)
            props.handleAppendTemplate(selectedRows.map(item => item.skuId))
        }
    }
    const handleBatchFillPrompt = () => {
        setDataSource(prev => prev.map(item => {
            if (selectedRowKeys.includes(item.skuId)) {
                return {
                    ...item,
                    prompt: promptDesc,
                }
            }
            return item
        }))
        setPromptModalOpen(false)
        setPromptDesc('')
        handleBatchExit()
    }

    const saveUploadImg = async (url) => {
        const updatedRows = selectedRows.map(item => {
            if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && batchMode === 'appendImageTail') {
                return {
                    ...item,
                    projectId,
                    imageTail: url,
                }
            }

            const newInputImages = [...item.inputImages];
            const nonMainIndex = newInputImages.findIndex(img => img.mainImage === false);

            if (nonMainIndex !== -1) {
                newInputImages[nonMainIndex] = {
                    ...newInputImages[nonMainIndex],
                    url,
                };
            } else {
                newInputImages.push({
                    mainImage: false,
                    url,
                });
            }

            return {
                ...item,
                projectId,
                inputImages: newInputImages,
            };
        });

        console.log("更新后的 selectedRows:", updatedRows);
        const saveRes = await API.batchSaveSku(updatedRows)
        if (saveRes?.code === 0) {
            props.listSkuByProject()
            handleBatchExit()
            setLoading(false)
        }
    };

    const promptPopoverContent = (
        <div className={styles.PromptPopoverMenu}>
            <div className={styles.PromptPopoverItem} onClick={() => handleBatchAction('appendPromptModel')}>填写视频画面描述</div>
            <div className={styles.PromptPopoverItem} onClick={() => handleBatchAction('appendPrompt')}>从描述模板中选择</div>
        </div>
    )

    // 批量操作
    const items = useMemo(() => {
        if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) {
            return [
                { key: "appendTop", label: "添加上装" },
                { key: "appendBottom", label: "添加下装" },
                { key: "appendModel", label: "设置模特图" },
                { key: "appendTryon", label: "设置模试衣参考图" },
                { key: "delete", label: "删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
            return [
                { key: "appendSmartPrompt", label: "AI分析" },
                { key: "appendSmartDetailRefer", label: "设置参考详情图" },
                { key: "delete", label: "删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
            return [
                { key: "appendModel", label: "设置模特图" },
                { key: "delete", label: "删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
            return [
                { key: "appendCustomBkg", label: "设置场景相似度" },
                { key: "appendBkg", label: "设置背景图" },
                { key: "delete", label: "删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
            return [
                { key: "appendCSimRecolorInput", label: "设置同款不同色平铺图" },
                { key: "appendCSimRecolorMaterial", label: "设置面料图" },
                { key: "appendCSimRecolorMatch", label: "设置搭配图" },
                { key: "delete", label: "删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH || projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
            return [
                { key: "delete", label: "删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
            return [
                { key: "appendModel", label: "设置网红" },
                { key: "appendBkg", label: "设置背景氛围图" },
                { key: "delete", label: "删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            return [
                { key: "appendImageTail", label: "设置尾帧图" },
                {
                    key: "appendPromptGroup",
                    label: <Popover trigger={['click', 'hover']} placement="rightTop" content={promptPopoverContent}>
                        <div className={styles.PromptPopoverTrigger}>
                            <span>设置视频画面描述</span><RightOutlined className={styles.PromptPopoverArrow} /></div>
                    </Popover>
                },
                { key: "delete", label: "删除" },
            ]
        }
    }, [projectType, promptPopoverContent])


    const handleSubmitConfig = async (submitMode = generateMode) => {
        if (dataSource.length === 0) {
            message.error('请先添加商品')
            return
        }
        setCreateLoading(true)
        if (!validateBeforeGenerate()) {
            setCreateLoading(false)
            setSubmitConfigVisible(false)
            return
        }

        // 检测未选参考图的sku
        const processedDataSource = dataSource.map(item => {
            // 创建新对象以避免直接修改原始数据
            const newItem = { ...item };

            // 根据projectType检查对应的数组长度
            if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH && (!item.refList || item.refList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH && (!item.modelList || item.modelList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && (!item.bkgList || item.bkgList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                (!hasSmartDetailInputImages(item) || !(item?.prompt || '').trim())) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH && !item.inputCloth) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && !(item?.prompt || '').trim()) {
                newItem.error = true;
            } else {
                newItem.error = false;
                newItem.error2 = false;
            }
            return newItem;
        })
        setDataSource(processedDataSource)

        // 检查是否有任何项设置了error = true
        const hasErrorItems = processedDataSource.some(item => item.error === true);
        // 检查是否有任何项设置了error2 = true
        const hasError2Items = processedDataSource.some(item => item.error2 === true);
        if (hasError2Items) {
            setCreateLoading(false);
            setSubmitConfigVisible(false)
            message.error('请填写完整商品颜色、类目、模板！');
            return;
        }

        if (hasErrorItems) {
            setCreateLoading(false)
            setSubmitConfigVisible(false)
            if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
                message.error('请填写完整视频画面描述！')
            } else {
                message.error('存在必填信息缺失的项，请先填写完整！')
            }
            return;
        }

        // 重新编辑发起
        if (isEdit) {
            try {
                const editSavePayload = (dataSource || []).map((item) => {
                    const { skuSerial, status, ...rest } = item || {}
                    return {
                        ...rest,
                        skuId: '',
                    }
                })
                const saveRes = await API.batchSaveSku(editSavePayload)
                if (saveRes?.code !== 0) throw new Error(saveRes?.message || '保存失败')
                const saveData = saveRes?.data
                const savedSkuId = typeof saveData === 'string'
                    ? saveData
                    : Array.isArray(saveData)
                        ? (saveData?.[0]?.skuId || saveData?.[0]?.id || saveData?.[0] || '')
                        : (saveData?.skuId || saveData?.id || '')
                if (!savedSkuId) throw new Error('保存结果缺少skuId')
                editAndGenerate(submitMode, savedSkuId)
            } catch (err) {
                setCreateLoading(false)
                message.error(err?.message || '保存失败')
                return
            }
            return
        }

        const prepared = await prepareSmartDetailSubmit()
        if (!prepared) {
            setCreateLoading(false)
            return
        }

        const startRes = await API.batchStartProject({
            projectId: projectId,
            num: handleNumber,
            mode: projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
                ? (submitMode === GENERATE_MODE.HQ ? '4K' : '2K')
                : submitMode,
            modelProvider: projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? modelProvider : undefined,
            ...(projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? { duration } : {}),
            ...getSmartDetailGenerateParams(submitMode),
            relightMode: relightMode,
            emoji: emoji,
            resolutionAlign: resolutionAlign,
            skinRefine: switchChecked ? 1 : 0,
            relight: relight,
        })
        setCreateLoading(false)
        if (startRes?.code === 0) {
            sessionStorage.removeItem('batchProductImagesPageIndex')
            message.success('项目发起成功')
            setSubmitConfigVisible(false)
            navigate(`/home/product/${projectId}/detail`)
        } else if (startRes?.code === -5012) {
            message.error('虹豆不足，请先购买会员')
            eventBus.emit('recharge')
        } else {
            message.error(startRes?.message)
        }
    }

    const editAndGenerate = async (submitMode = generateMode, savedSkuId = '') => {
        const startRes = await API.editAndGenerate({
            ...dataSource[0],
            ...(savedSkuId ? { skuId: savedSkuId } : {}),
            num: handleNumber,
            mode: projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
                ? (submitMode === GENERATE_MODE.HQ ? '4K' : '2K')
                : submitMode,
            modelProvider: projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? modelProvider : undefined,
            ...(projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? { duration } : {}),
            ...getSmartDetailGenerateParams(submitMode),
            relightMode: relightMode,
            emoji: emoji,
            resolutionAlign: resolutionAlign,
            skinRefine: switchChecked ? 1 : 0,
            relight: relight,
            projectId
        })
        setCreateLoading(false)
        if (startRes?.code === 0) {
            navigate(`/home/product/${projectId}/detail`)
        } else {
            message.error(startRes?.message)
        }
    }

    const handleSubmitConfirm = () => {
        const shouldForceHqConfirm = projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH &&
            generateMode === GENERATE_MODE.STD &&
            (dataSource || []).some(item => !!item?.imageTail)

        if (!shouldForceHqConfirm) {
            handleSubmitConfig()
            return
        }

        PSAIModal.confirm({
            content: <>
                <p>已上传首尾帧的任务生成模式仅支持高品质，</p>
                <p>此类型项目将为您切换至高品质生成模式</p>
            </>,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                handleSubmitConfig()
            }
        })
    }

    useEffect(() => {
        if (!dataSource || dataSource.length === 0) return;

        const totalLength = dataSource.reduce((sum, item) => {
            const bkgCount = item?.bkgList?.length || 0;
            const modelCount = projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? 0 : item?.modelList?.length;
            const refCount = item?.refList?.length || 0;
            return sum + bkgCount + modelCount + refCount;
        }, 0);

        setTotal(totalLength)
    }, [dataSource]);

    const Text1 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '试衣参考图' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '模特参考图' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '背景参考图' :
                    ''
    }, [projectType])
    const Text2 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '添加商品图' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
                projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ||
                projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '添加模特图' :
                projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '添加首帧图' :
                    projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '添加源素材' :
                        projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH || projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '新增任务' :
                            '添加输入图'
    }, [projectType])
    const Text3 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? ' 个商品' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? ' 张模特图' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? ' 张模特图' :
                    projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? ' 张源素材' :
                        projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? ' 组穿搭' :
                            projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? ' 组详情页' :
                                projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? ' 组源素材' :
                                    projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? ' 张首帧图' :
                                        '张输入图'
    }, [projectType])

    const grassPlantCounts = useMemo(() => {
        return (dataSource || []).reduce((acc, item) => {
            acc.model += item?.modelList?.length || 0
            acc.bkg += item?.bkgList?.length || 0
            return acc
        }, { model: 0, bkg: 0 })
    }, [dataSource])

    const costInfo = useMemo(() => {
        let cost = 0;
        let desc = '';
        const len = dataSource?.length || 0;
        const smartDetailImageCount = getSmartDetailImageCount(smartDetailConfigItems)
        const getSmartDetailSkuImageCount = (item) => {
            if (Array.isArray(item?.refList) && item.refList.length > 0) {
                return Number(item?.detailPageNum) || 0
            }
            return (Array.isArray(item?.customCompList) ? item.customCompList : []).reduce((sum, comp) => {
                return sum + (Number(comp?.num) || 0)
            }, 0)
        }

        switch (projectType) {
            case BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH:
                cost = len * handleNumber * 5;
                desc = `源素材${len}张*每张素材图生成${handleNumber}张* 5虹豆`;
                break;
            case BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH:
                cost = len * handleNumber * 10;
                desc = `模特图${len}张*每张模特图生成${handleNumber}张* 10虹豆`;
                break;
            case BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH:
                cost = len * handleNumber * 10;
                desc = `输入图${len}张*每张模特图生成${handleNumber}张* 10虹豆`;
                break;
            case BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH:
                cost = len * handleNumber * 10;
                desc = `每张源素材生成${handleNumber}张* 10虹豆`;
                break;
            case BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH:
                const smartDetailPrice = generateMode === GENERATE_MODE.HQ ? 120 : 80;
                const totalSmartDetailImageCount = (dataSource || []).reduce((sum, item) => {
                    return sum + getSmartDetailSkuImageCount(item)
                }, 0)
                cost = totalSmartDetailImageCount * smartDetailPrice;
                desc = `（${len}组详情页：共${len * smartDetailImageCount}张图片）*${smartDetailPrice}虹豆`;
                break;
            case BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH:
                cost = total * handleNumber * 10;
                desc = `背景参考图${total}张*每张参考图生成${handleNumber}张*${10}虹豆`;
                break;
            case BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH:
                const grassPairCount = (dataSource || []).reduce((sum, item) => {
                    const bkgCount = item?.bkgList?.length || 1
                    const modelCount = item?.modelList?.length || 1
                    return sum + (bkgCount * modelCount)
                }, 0)
                const grassPrice = generateMode === GENERATE_MODE.STD ? 10 : 15;
                cost = grassPairCount * handleNumber * grassPrice;
                desc = `源素材组合${grassPairCount}组(背景氛围图×网红图)*每组生成${handleNumber}张*${grassPrice}虹豆`;
                break;
            case BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH:
                const hasTailCount = (dataSource || []).filter(item => !!item?.imageTail).length
                const normalCount = Math.max(len - hasTailCount, 0)
                const stdPrice = duration === 10 ? 220 : 110
                const hqPrice = duration === 10 ? 400 : 200
                const normalPrice = generateMode === GENERATE_MODE.HQ ? hqPrice : stdPrice
                cost = (normalCount * normalPrice + hasTailCount * hqPrice)
                desc = `视频${len}组*${duration}s（标准${stdPrice}虹豆/高品质${hqPrice}虹豆${hasTailCount > 0 ? `，含尾帧图${hasTailCount}组按高品质计费` : ''}）`
                break;
            case BATCH_IMAGES_TYPE.TRYON_BATCH:
                const tryonPrice = modelProvider === MODEL_PROVIDER.SOTA
                    ? (generateMode === GENERATE_MODE.STD ? 80 : 120)
                    : (generateMode === GENERATE_MODE.STD ? 10 : 15)
                cost = total * handleNumber * tryonPrice;
                desc = `试衣参考图${total}张*每张参考图生成${handleNumber}张*${tryonPrice}虹豆`;
                break;
            default:
                const price = generateMode === GENERATE_MODE.STD ? 10 : 15;
                cost = total * handleNumber * price;
                desc = `试衣参考图${total}张*每张参考图生成${handleNumber}张*${price}虹豆`;
        }
        if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
            const smartDetailFinalPrice = generateMode === GENERATE_MODE.HQ ? 120 : 80
            const smartDetailFinalImageCount = (dataSource || []).reduce((sum, item) => {
                return sum + getSmartDetailSkuImageCount(item)
            }, 0)
            cost = smartDetailFinalImageCount * smartDetailFinalPrice
            desc = `（${len}组详情页：共${smartDetailFinalImageCount}张图片）*${smartDetailFinalPrice}虹豆`
        }
        return { cost, desc }
    }, [projectType, dataSource, handleNumber, total, generateMode, duration, modelProvider, smartDetailConfigItems])

    const relightModeItems = [{
        text: '标准模式',
        value: projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? RELIGHT_MODE.PORTRAIT : RELIGHT_MODE.SKIN,
    }, {
        text: '反光板模式',
        value: RELIGHT_MODE.REFLECTOR,
    }]

    const emojiList = [{
        text: '按原模特',
        value: MODEL_EXPRESSION.SRC,
    }, {
        text: '按模特参考图',
        value: MODEL_EXPRESSION.REF,
    }]

    const contentList = [{
        url: '1.png',
        title: '标准模式',
        smallTitle: '使人物与环境的光影和谐一致',
    }, {
        url: '2.png',
        title: '标准模式',
        smallTitle: '使人脸与身体的光影和谐一致',
    }, {
        url: '3.png',
        title: '反光板模式',
        smallTitle: '使人脸光影更柔和，降低对比度',
    }].filter(item => {
        if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && item.url === '2.png') return false
        else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH && item.url === '1.png') return false
        return true
    })

    const ContentBox = (
        <div className={styles.ContentBox}>
            {
                contentList.map((item) => (
                    <div key={item.value} className={styles.ContentItem}>
                        <img src={BASE_URL + item.url} alt={item.title} />
                        <div className={styles.title}>{item.title}</div>
                        <div className={styles.smallTitle}>{item.smallTitle}</div>
                    </div>
                ))
            }
        </div>
    )

    return (
        <div className={styles.FooterBar}>
            {
                uploading ?
                    <>
                        <div className={styles.FooterBarLeft}>
                            <Button disabled className={styles.BatchTrigger}>批量操作</Button>
                        </div>
                        <div className={styles.FooterBarRight}>
                            <div className={styles.BtnGroup}>
                                <Button style={{ width: 200, height: 36 }} disabled={true}>添加源素材</Button>
                                <Button style={{ width: 200, height: 36 }} type="primary" disabled={true}>帮我作图</Button>
                            </div>
                        </div>
                    </> :
                    <>
                        {
                            !isEdit ? <div className={styles.FooterBarLeft}>
                                {
                                    batchMode ?
                                        <Space>
                                            <Button
                                                disabled={selectedRowKeys?.length == 0}
                                                onClick={handleBatchSubmit}
                                                loading={loading}
                                                className={`${styles.BatchTrigger} ${selectedRowKeys?.length > 0 && !loading ? styles.AttentionPulse : ''}`}>
                                                {batchMode == 'appendSmartDetailRefer' && props.smartDetailReferLoading && <LoadingOutlined style={{ marginRight: 8 }} />}
                                                {(items.find(item => item.key == batchMode)?.label) || ((batchMode == 'appendPromptModel' || batchMode == 'appendPrompt') ? '设置视频画面描述' : '')}
                                            </Button>
                                            <span
                                                className={styles.BatchTrigger}
                                                style={{ marginLeft: 24, color: '#006EFF', fontSize: 14, cursor: 'pointer' }}
                                                onClick={handleBatchExit}>取消
                                            </span>
                                        </Space> :
                                        <Dropdown
                                            trigger={['click']}
                                            overlayClassName='BatchMenu'
                                            menu={{ items, onClick: handleBatchClick }}
                                            placement="top">
                                            <Button className={styles.BatchTrigger}>批量操作</Button>
                                        </Dropdown>
                                }
                            </div> : <span></span>
                        }
                        {
                            isEdit ? <div className={styles.FooterBarRight}>
                                <div className={styles.BtnGroup}>
                                    <div className={styles.SubmitBtn}>
                                        <Button style={{ width: 200, height: 36 }} type="primary" loading={submitPrepareLoading} onClick={openSubmitConfig}>生成</Button>
                                    </div>
                                </div>
                            </div> : !batchMode ? <div className={styles.FooterBarRight}>
                                <div className={styles.TaskInfo}>
                                    {
                                        projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ?
                                            <span>{skuNumber}{Text3}</span> :
                                            projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ?
                                                <span>{skuNumber}{Text3} · {grassPlantCounts.model} 张网红图 · {grassPlantCounts.bkg} 张背景氛围图</span> :
                                                <span>{skuNumber}{Text3} · {total} 张{Text1}</span>
                                    }
                                </div>
                                <div className={styles.BtnGroup}>
                                    <Button style={{ width: 200, height: 36 }} onClick={onAddMore}>{Text2}</Button>
                                    <div className={styles.SubmitBtn}>
                                        <Button style={{ width: 200, height: 36 }} type="primary" loading={submitPrepareLoading} onClick={openSubmitConfig}>发起批量生成</Button>
                                    </div>
                                </div>
                            </div> : null
                        }
                    </>
            }
            <PSAIModal
                title="批量添加描述"
                open={promptModalOpen}
                maskClosable={false}
                maxWidth={528}
                onCancel={() => setPromptModalOpen(false)}
                onOk={handleBatchFillPrompt}
                getContainer={"body"}
                zIndex={10000}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: '24px 24px 0 24px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <div style={{ fontSize: 14, lineHeight: '20px', color: '#000812', fontWeight: 600 }}>描述</div>
                        <Input.TextArea value={promptDesc} onChange={(e) => setPromptDesc(e.target.value)} placeholder="请输入描述" maxLength={800} autoSize={{ minRows: 8, maxRows: 8 }} />
                    </div>
                </div>
            </PSAIModal>
            <PSAIModal
                title={projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '设置视频生成参数' : '设置生图参数'}
                maxWidth={564}
                okText={'确定'}
                open={submitConfigVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: createLoading }}
                onCancel={() => setSubmitConfigVisible(false)}
                onOk={() => handleSubmitConfirm()}
            >
                <div className={styles.submitConfigWrap}>
                    {
                        projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH && (
                            <>
                                <div className={styles.submitConfigItem} style={{ alignItems: 'center' }}>
                                    <span style={smartDetailLabelStyle}>生成比例</span>
                                    <Select
                                        value={smartDetailRatio}
                                        options={smartDetailRatioOptions}
                                        onChange={setSmartDetailRatio}
                                        style={{ width: smartDetailControlWidth, height: smartDetailControlHeight }}
                                        popupMatchSelectWidth
                                    />
                                </div>
                                <div className={styles.submitConfigItem} style={{ alignItems: 'center' }}>
                                    <span style={smartDetailLabelStyle}>图片清晰度</span>
                                    <div className={styles.PickerContent} style={{ gap: 12, marginTop: 0 }}>
                                        {[
                                            { label: '2K', value: GENERATE_MODE.STD },
                                            { label: '4K', value: GENERATE_MODE.HQ },
                                        ].map(item => (
                                            <div
                                                key={item.value}
                                                className={`${styles.PickerItem} ${generateMode == item.value && styles.actived}`}
                                                onClick={() => setGenerateMode(item.value)}
                                                style={{ width: smartDetailClarityItemWidth, height: smartDetailControlHeight }}
                                            >
                                                <span>{item.label}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className={styles.submitConfigItem} style={{ alignItems: 'center' }}>
                                    <span style={smartDetailLabelStyle}>电商平台</span>
                                    <Select
                                        value={smartDetailPlatform}
                                        options={smartDetailPlatformOptions}
                                        onChange={setSmartDetailPlatform}
                                        style={{ width: smartDetailControlWidth, height: smartDetailControlHeight }}
                                        popupMatchSelectWidth
                                    />
                                </div>
                                <div className={styles.submitConfigItem} style={{ alignItems: 'center' }}>
                                    <span style={smartDetailLabelStyle}>语言</span>
                                    <Select
                                        value={smartDetailLang}
                                        options={smartDetailLangOptions}
                                        onChange={setSmartDetailLang}
                                        style={{ width: smartDetailControlWidth, height: smartDetailControlHeight }}
                                        popupMatchSelectWidth
                                    />
                                </div>
                            </>
                        )
                    }
                    {
                        projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                        (
                            projectType !== BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) &&
                        <div className={styles.submitConfigItem}>
                            <span>{[
                                BATCH_IMAGES_TYPE.TRYON_BATCH,
                                BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH,
                                BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH,
                                BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH,
                                BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH,
                            ].includes(projectType) ? '每组参考图生成张数' : '每组源素材生成张数'}</span>
                            <p>{
                                Array.from({ length: 4 }).map((_, i) => <span className={handleNumber == i + 1 ? styles.active : ''} onClick={() => setHandleNumber(i + 1)} key={i}>{i + 1}张</span>)
                            }</p>
                        </div>
                    }
                    {
                        projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                        projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && <div className={styles.submitConfigItem}>
                            <span>生成图比例
                                <Popover content={<p className={styles.PopoverContent}>
                                    <p><span>上传图比例</span> 按上传图比例生成</p>
                                    <p><span>参考图比例</span> 按已选背景参考图比例</p>
                                </p>}>
                                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                </Popover>
                            </span>
                            <div className={styles.PickerContent}>
                                {
                                    resolutionAlignItems.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${resolutionAlign == item.value && styles.actived}`}
                                            onClick={() => setResolutionAlign(item.value)}
                                        >
                                            <span>{item.title}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                    {
                        projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                        projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH &&
                        <div className={styles.submitConfigItem}>
                            <span>视频生成时长</span>
                            <div className={styles.PickerContent}>
                                {
                                    durationItems.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${duration == item.value && styles.actived}`}
                                            onClick={() => setDuration(item.value)}
                                        >
                                            <span>{item.title}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                    {
                        projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                        projectType === BATCH_IMAGES_TYPE.TRYON_BATCH &&
                        <div className={styles.submitConfigItem}>
                            <span>模型选择</span>
                            <div className={styles.PickerContent}>
                                {
                                    modelProviderItems.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${modelProvider == item.value && styles.actived}`}
                                            onClick={() => setModelProvider(item.value)}
                                        >
                                            <span>{item.title}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                    {
                        projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                        (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
                            projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ||
                            projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) &&
                        <div className={styles.submitConfigItem}>
                            <span>生成模式
                                <Popover content={<p className={styles.PopoverContent}>
                                    <p><span>{modeItemsWithLabel[0]?.title}</span> 生成速度更快</p>
                                    <p><span>{modeItemsWithLabel[1]?.title}</span> 生成时间稍长，生成效果更好</p>
                                </p>}>
                                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                </Popover>
                            </span>
                            <div className={styles.PickerContent}>
                                {
                                    modeItemsWithLabel.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                                            onClick={() => setGenerateMode(item.value)}
                                        >
                                            <span>{item.title}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }

                    {
                        projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
                        ![
                            BATCH_IMAGES_TYPE.TRYON_BATCH,
                            BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH,
                            BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH,
                            BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH,
                            BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH,
                            BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH,
                            BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH,
                        ].includes(projectType) &&
                        <>
                            {
                                projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH &&
                                <div className={styles.submitConfigItemModel}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>模特表情</div>
                                    <div className={styles.PickerContent} style={{ marginTop: 0 }}>
                                        {
                                            emojiList.map((item) => (
                                                <Button
                                                    key={item.value}
                                                    className={`${styles.PickerItem} ${emoji == item.value && styles.actived}`}
                                                    onClick={() => setEmoji(item.value)}
                                                >
                                                    {item.text}
                                                </Button>
                                            ))
                                        }
                                    </div>
                                </div>

                            }
                            {
                                projectType !== BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH &&
                                <div className={styles.submitConfigItemModel}>
                                    <div>
                                        <p>人像皮肤优化
                                            <Popover content={'开启后人像肤质细节会更精致，但将增加生成时间'}>
                                                <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                            </Popover>
                                        </p>
                                    </div>
                                    <div><Switch style={{ marginRight: 8 }}
                                        checked={switchChecked}
                                        onChange={() => setSwitchChecked(!switchChecked)} />
                                        {switchChecked ? '开启' : '关闭'}</div>
                                </div>
                            }
                            <div className={styles.submitConfigItemModel}>
                                <div>
                                    <p>光影增强
                                        <Popover content={ContentBox} placement="right">
                                            <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                        </Popover>
                                    </p>
                                </div>
                                <div><Switch
                                    style={{ marginRight: 8 }}
                                    checked={switchChecked2}
                                    onChange={(v) => {
                                        setSwitchChecked2(v)
                                        setRelight(v ? 1.0 : 0.0)
                                    }} />{switchChecked2 ? '开启' : '关闭'}</div>
                            </div>
                            {
                                relight > 0.0 && <div className={styles.PickerContent}>
                                    {
                                        relightModeItems.map((item) => (
                                            <Button
                                                key={item.value}
                                                className={`${styles.PickerItem} ${relightMode == item.value && styles.actived}`}
                                                onClick={() => setRelightMode(item.value)}
                                            >
                                                {item.text}
                                            </Button>
                                        ))
                                    }
                                </div>
                            }
                            {
                                relight > 0.0 && <div className={styles.SliderWrap}>
                                    <span>更像原图</span>
                                    <Slider className={styles.Slider} max={1.4} min={0.8} value={relight} step={0.1} onChange={value => setRelight(value)} />
                                    <span>更加自然</span>
                                </div>
                            }
                        </>
                    }

                    <div className={styles.submitConfigBottom}>
                        <p>预计消耗<img style={{ margin: '0 12px', width: '32px', height: '32px' }}
                            src={require('@assets/images/arcbean3.png')} alt="" />
                            <span className={styles.arcbean}>{costInfo.cost}</span></p>
                        <p>{costInfo.desc}</p>
                    </div>
                </div>
            </PSAIModal>
        </div>
    )
})

export default FooterBar
